const ClaimMethod = ({ value = '', isVerified = false, canBeRemoved = true } = {}) => ({
  value: String(value),
  isVerified: Boolean(isVerified),
  canBeRemoved: Boolean(canBeRemoved),
});

export default ClaimMethod;

export type ClaimMethodProps = ReturnType<typeof ClaimMethod>;
